import { gql } from '@apollo/client';

export const CHECK_SAME_AREA_ENABLED = gql`
    query CheckSameAreaEnabled {
        checkSameAreaEnabled
    }
`;

export interface CheckSameAreaEnabledResponse {
    checkSameAreaEnabled: boolean;
}


export const IS_OPEN_DSP_SCAN_GRAY = gql`
    query IsOpenDspScanGray {
        isOpenDspScanGray
    }
`;


